import {
  InternalTooltip,
  InternalOverlay,
  type InternalSliceData,
} from './internal/pie-chart.js';

export interface PieChartState {
  tooltip: InternalTooltip;
  overlay: InternalOverlay;
  highlightedIds: string[];
  visibleSlices: InternalSliceData[];
}

export const initialState: PieChartState = {
  tooltip: {
    pinned: false,
    visible: false,
  },
  overlay: {
    mouseInBounds: false,
  },
  highlightedIds: [],
  visibleSlices: [],
};
